import React from "react";
import PropTypes from "prop-types";
import BlankScreenIllustration from '../../assets/BlankScreenIllustration.svg';

const EmptyStateNotice = ({ title, description }) => {
  return (
    <div
      style={{
        textAlign: "center",
        padding: "40px 16px",
        maxWidth: "400px",
        margin: "0 auto",
      }}
    >
      <div style={{ marginBottom: "12px",marginTop:"65px" }}>
       <img src={BlankScreenIllustration} alt={"empty icon"} ></img>
      </div>
      <h3 style={{ fontSize: "18px", fontWeight: 600, color: "#333", marginBottom: "8px" }}>
        {title}
      </h3>
      <p style={{ fontSize: "14px", color: "#666" }}>
        {description}
      </p>
    </div>
  );
};

EmptyStateNotice.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default EmptyStateNotice;
